export const strategyConfig = Object.freeze({
    email: Object.freeze({
        id: 'email',
        name: 'Email',
        icon: 'sym_r_mail',
        order: 1
    }),
    github: Object.freeze({
        id: 'github',
        name: 'GitHub',
        domain: 'github.com',
        icon: 'img:/icons/brand-logo_github.svg',
        iconDark: 'img:/icons/brand-logo_github_white.svg',
        order: 2
    }),
    gitlab: Object.freeze({
        id: 'gitlab',
        name: 'GitLab',
        domain: 'gitlab.com',
        icon: 'img:/icons/brand-logo_gitlab.svg',
        iconDark: 'img:/icons/brand-logo_gitlab_white.svg',
        order: 3
    }),
    google: Object.freeze({
        id: 'google',
        name: 'Google',
        domain: 'google.com',
        icon: 'img:/icons/brand-logo_google.svg',
        order: 4
    }),
    linkedin: Object.freeze({
        id: 'linkedin',
        name: 'LinkedIn',
        domain: 'linkedin.com',
        icon: 'img:/icons/brand-logo_linkedin.svg',
        iconDark: 'img:/icons/brand-logo_linkedin_white.svg',
        order: 5
    })
});
